<ngx-ui-loader [loaderId]="'loader-03'"></ngx-ui-loader>

<div>
  <!-- Alerts -->
  <div class="w-full p-2">
    <div
      class="font-bold text-center text-red-600 alert alert-light"
      *ngIf="sourceselect"
      @fade
    >
      IF FUNDING FOR THIS CONTRACT IS PROCESSED THROUGH YOUR OFFICE PLEASE
      SUBMIT AS AN ADDITIONAL PURCHASE TRANSACTION
    </div>

    <div
      class="font-bold text-center text-red-600 alert alert-light"
      *ngIf="editsource"
    >
      Note: If Product Type or Source of Funds are changed you will lose data
      previously entered. Review data will also be lost once you hit save.
    </div>
<!-- 
    <div
      class="font-bold text-center text-red-600 alert alert-light"
      *ngIf="osjValid"
    >
      Warning: Submit check transactions between 5:00 a.m. - 12:00 p.m. (noon)
      EST. To submit a check transaction outside this time window, please
      contact the home office.
    </div> -->

    <div
      class="font-bold text-center text-red-600 alert alert-light"
      *ngIf="checkWarning"
    >
      Warning: You have missed the daily deadline for check transactions. Please
      contact the home office immediately.
    </div>
    <div class="flex items-center justify-center text-md">
      <span class="p-4 border rounded-lg">
        Questions or comments? Insurance:
        <a
          href="mailto:cia@capital-invest.com"
          class="text-blue-500 hover:underline"
        >
          cia&#64;capital-invest.com
        </a>
        <span class="mx-2">|</span>
        Trading:
        <a
          href="mailto:CICTrading@capital-invest.com"
          class="text-blue-500 hover:underline"
        >
          CICTrading&#64;capital-invest.com
        </a>
      </span>
    </div>
  </div>

  <!-- Show Top Row Button -->
  <div class="float-right mr-10" *ngIf="!hidetoprow">
    <div class="p-2 rounded shadow-md card">
      <button
        kendoButton
        look="outline"
        size="small"
        type="button"
        (click)="togglehidetoprow()"
      >
        Show top
      </button>
    </div>
  </div>

  <!-- Form Section -->
  <form
    [formGroup]="firstForm"
    (ngSubmit)="onFirstSubmit()"
    [ngClass]="{ 'hidden-class': !hidetoprow }"
  >
    <div class="flex flex-row flex-wrap gap-4">
      <!-- Client Information Card -->
      <div
        class="card shadow-md p-4 rounded w-[35em] h-[25.5rem] overflow-hidden"
        @fade
      >
        <h3 class="flex items-center mb-3 font-semibold">
          <kendo-icon name="user"></kendo-icon>&nbsp;Client Information
        </h3>
        <div class="space-y-3">
          <!-- Rep -->
          <div class="flex items-center space-x-2" *ngIf="RepExists">
            <label class="flex items-center tiny">
              <kendo-icon name="user"></kendo-icon>&nbsp;Rep:
            </label>
            <kendo-combobox
              class="repComboBox"
              #combo
              [suggest]="true"
              (focus)="onFocus(combo)"
              [virtual]="virtual"
              [loading]="false"
              (selectionChange)="selectionChange($event)"
              formControlName="RepId"
              [kendoDropDownFilter]="filterSettings"
              [valuePrimitive]="true"
              [data]="clientlistItems"
              textField="fullName"
              valueField="repId"
              placeholder="Select Rep..."
              required
            >
            </kendo-combobox>
          </div>

          <!-- Rep Code -->
          <div class="flex items-center space-x-2">
            <label class="flex items-center tiny">
              <kendo-icon name="file"></kendo-icon>&nbsp;Rep Code:
            </label>
            <kendo-dropdownlist
              required
              #repsel
              formControlName="repCodeId"
              (selectionChange)="selectionChangeRepCode($event)"
              [valuePrimitive]="true"
              [virtual]="virtual"
              [loading]="loaderCode"
              [data]="repcodelistItems"
              textField="repCode"
              valueField="repCodeId"
              class="w-[350px]"
            >
            </kendo-dropdownlist>
          </div>

          <!-- Client -->
          <div class="flex items-center space-x-2">
            <label class="flex items-center tiny">
              <kendo-icon name="user"></kendo-icon>&nbsp;Client:
            </label>
            <kendo-dropdownlist
              required
              #drop
              formControlName="clientTax"
              (valueChange)="handleFilter()"
              (selectionChange)="selectionChangeClient($event)"
              [valuePrimitive]="true"
              name="ourrep"
              [virtual]="virtual"
              [loading]="loaderTypeClient"
              [data]="clientthirdlisting"
              textField="firstName"
              valueField="clientId"
              class="w-[350px]"
            >
            </kendo-dropdownlist>
          </div>

          <!-- Terminated Rep Notice -->
          <div
            *ngIf="repwasterminated"
            class="text-sm font-medium text-red-600"
          >
            * Rep is no longer available, Please select a new rep.
          </div>
        </div>
      </div>

      <!-- Product and Transaction Information Card -->
      <div class="card shadow-md p-4 rounded h-[25.5rem]" @fade>
        <h3 class="mb-3 font-semibold">Product and Transaction Information</h3>
        <div class="space-y-3">
          <!-- Product Type -->
          <div class="flex items-center space-x-2">
            <label class="tiny">Product Type:</label>
            <kendo-dropdownlist
              (selectionChange)="selectionChangeProductTypes($event)"
              (valueChange)="handleFilter()"
              #drop
              formControlName="productTypeId"
              [valuePrimitive]="true"
              [virtual]="virtual"
              [loading]="false"
              [data]="productlisting"
              textField="productTypeDesc2"
              valueField="productTypeId"
              class="w-[250px] ml-2"
            >
            </kendo-dropdownlist>
          </div>

          <!-- Transaction Type -->
          <div class="flex items-center space-x-2">
            <label class="tiny">Transaction Type:</label>
            <kendo-dropdownlist
              (selectionChange)="selectionChangetypes($event)"
              #drop
              formControlName="transact"
              [valuePrimitive]="true"
              [virtual]="virtual"
              [loading]="loadetrans"
              [data]="translisting"
              textField="transactionTypeDesc"
              valueField="transactionTypeId"
              (valueChange)="handleFilter()"
              class="w-[250px] ml-2"
            >
            </kendo-dropdownlist>
          </div>

          <!-- Continue Button -->
          @if (accountformTrue) {
          <div class="pr-2 text-right">
            <button
              kendoButton
              size="small"
              type="button"
              [disabled]="!firstForm.get('repCodeId').value"
              (click)="cpSubmit()"
            >
              Continue
            </button>
          </div>
          }
        </div>
      </div>
      @if (source) {
      <div class="card shadow-md p-4 rounded h-[25.5rem]" @fade>
        <h3 class="mb-3 font-semibold">Source of the funds for the purchase</h3>
        <div class="space-y-3">
          <div class="flex flex-col gap-3">
            <div class="spacing">
              <div
                *ngFor="let option of sourceFundtypelist"
                class="flex items-center gap-2"
              >
                <kendo-radiobutton
                  #checked
                  [value]="option.sourceOfFundsTypeId"
                  (click)="changestatus(option.sourceOfFundsTypeId)"
                  name=" sourcetypes"
                  [(ngModel)]="selectedSourceFundType"
                  formControlName="sourcetypes"
                >
                </kendo-radiobutton>
                <kendo-label
                  class="k-radio-label"
                  [for]="checked"
                  [text]="option.sourceOfFundsTypeDesc"
                ></kendo-label>
              </div>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  </form>

  <!-- Step 2 Form -->
  <div
    *ngIf="showStep2Form() && firstForm.valid && !checkWarning"
    class="ml-3"
    [kendoLoader]="showbtn"
  >
    <div
      class="card shadow-md p-4 rounded w-full min-w-[1030px] overflow-hidden"
    >
      <gd-step2form
        [RepSelected]="RepSelected"
        [clientId]="clientId"
        [ClientSelected]="ClientSelected"
        [productTypeSelected]="productTypeSelected"
        [transactionTypeSelected]="transactionTypeSelected"
        [SourceofFundsSelected]="SourceofFundsSelected"
        [RepCodeSelected]="RepCodeSelected"
        [repNamestring]="repNamestring"
        [repCodestring]="repCodestring"
        [Clientstring]="Clientstring"
        [productTypestring]="productTypestring"
        [stateof]="stateof"
        [transactionTypestring]="transactionTypestring"
        [sourceoffundsstring]="sourceoffundsstring"
        [clientthirdlisting]="clientthirdlisting"
        [taxen]="taxen"
        [InvObjectiveId]="InvObjectiveId"
        [LiquidityNeedsId]="LiquidityNeedsId"
        [InvestmentTimeHorizonId]="InvestmentTimeHorizonId"
        [InvestmentProfileId]="InvestmentProfileId"
        [AnnualIncFrom]="AnnualIncFrom"
        [AnnualIncTo]="AnnualIncTo"
        [NetWorthFrom]="NetWorthFrom"
        [NetWorthTo]="NetWorthTo"
        [LiquidNWFrom]="LiquidNWFrom"
        [loading]="loading"
        [LiquidNWTo]="LiquidNWTo"
        [InvestDescription]="InvestDescription"
        [statusTypeId]="StatusTypeId"
        [InvestmentTimeHorizonDescription]="InvestmentTimeHorizonDescription"
        [ProfileDescription]="ProfileDescription"
        [LiquidDescription]="LiquidDescription"
        [dob]="$any(dob)"
        [Email]="Email"
        (submitEvent)="onSecondSubmit($event)"
      >
      </gd-step2form>
    </div>
  </div>
</div>
